var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4488 2.16421C12.3187 2.05779 12.1584 2 11.9934 2C11.8284 2 11.6681 2.05779 11.538 2.16421L1.42109 10.4392C1.16422 10.6493 1.05237 10.9892 1.13428 11.3108L1.16072 11.4146C1.21317 11.6205 1.36311 11.7877 1.56213 11.8621C1.77846 11.9431 2.02151 11.9029 2.2003 11.7567L3.2 10.939V20.4615C3.20078 20.8693 3.35555 21.2601 3.63043 21.5485C3.90532 21.8368 4.27792 21.9992 4.66667 22H19.3333C19.7221 21.9992 20.0947 21.8368 20.3696 21.5485C20.6445 21.2601 20.7992 20.8693 20.8 20.4615V10.9459L21.7954 11.7601C21.9766 11.9083 22.2233 11.9479 22.4418 11.8639C22.6386 11.7882 22.7867 11.622 22.8391 11.4177L22.8648 11.3175C22.9472 10.9962 22.8356 10.6562 22.5788 10.4462L12.4488 2.16421ZM13.4667 20.4615H10.5333V14.3075H13.4667V20.4615ZM14.9333 20.4615V14.3075C14.9329 13.8996 14.7783 13.5085 14.5033 13.2201C14.2284 12.9317 13.8555 12.7695 13.4667 12.769H10.5333C10.1445 12.7695 9.77164 12.9317 9.49667 13.2201C9.2217 13.5085 9.06705 13.8996 9.06667 14.3075V20.4615H4.66667V9.73975L12 3.74732L19.3333 9.74744V20.4615H14.9333Z",
    fill: "#3545DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.13d457dbcd9cab5e463208a663412bd0.svg";
export { ForwardRef as ReactComponent };